export type ComparisonEntry = {
	slug: string;
	title: string;
	href: string;
};

/**
 * List of comparison / "alternative" pages surfaced on the /compare hub.
 * Add a new entry here when a new comparison page is created.
 */
export const COMPARISONS: ComparisonEntry[] = [
	{
		slug: 'binary-vs-greenhouse',
		title: 'Binary vs Greenhouse',
		href: '/compare/binary-vs-greenhouse',
	},
	{
		slug: 'binary-vs-ashby',
		title: 'Binary vs Ashby',
		href: '/compare/binary-vs-ashby',
	},
	{
		slug: 'binary-vs-workable',
		title: 'Binary vs Workable',
		href: '/compare/binary-vs-workable',
	},
	{
		slug: 'binary-vs-lever',
		title: 'Binary vs Lever',
		href: '/compare/binary-vs-lever',
	},
	{
		slug: 'binary-vs-teamtailor',
		title: 'Binary vs Teamtailor',
		href: '/compare/binary-vs-teamtailor',
	},
	{
		slug: 'binary-vs-dover',
		title: 'Binary vs Dover',
		href: '/compare/binary-vs-dover',
	},
	{
		slug: 'binary-vs-keka',
		title: 'Binary vs Keka',
		href: '/compare/binary-vs-keka',
	},
	{
		slug: 'binary-vs-zoho-recruit',
		title: 'Binary vs Zoho Recruit',
		href: '/compare/binary-vs-zoho-recruit',
	},
	{
		slug: 'binary-vs-freshteam',
		title: 'Binary vs Freshteam',
		href: '/compare/binary-vs-freshteam',
	},
	{
		slug: 'binary-vs-breezy',
		title: 'Binary vs Breezy HR',
		href: '/compare/binary-vs-breezy',
	},
	{
		slug: 'binary-vs-jazzhr',
		title: 'Binary vs JazzHR',
		href: '/compare/binary-vs-jazzhr',
	},
	{
		slug: 'binary-vs-rippling',
		title: 'Binary vs Rippling',
		href: '/compare/binary-vs-rippling',
	},
	{
		slug: 'binary-vs-recruit-crm',
		title: 'Binary vs Recruit CRM',
		href: '/compare/binary-vs-recruit-crm',
	},
	{
		slug: 'binary-vs-recruitee',
		title: 'Binary vs Recruitee',
		href: '/compare/binary-vs-recruitee',
	},
	{
		slug: 'binary-vs-bamboohr',
		title: 'Binary vs BambooHR',
		href: '/compare/binary-vs-bamboohr',
	},
	{
		slug: 'binary-vs-homerun',
		title: 'Binary vs Homerun',
		href: '/compare/binary-vs-homerun',
	},
	{
		slug: 'binary-vs-gem',
		title: 'Binary vs Gem',
		href: '/compare/binary-vs-gem',
	},
];

/**
 * Comparison pages featured in the site footer. Not every comparison page
 * belongs here; list the slugs to surface explicitly, in the order they should
 * appear. Add a slug here only when we want that page in the footer.
 */
const FOOTER_COMPARISON_SLUGS = [
	'binary-vs-greenhouse',
	'binary-vs-ashby',
	'binary-vs-workable',
	'binary-vs-lever',
];

export const TOP_FOOTER_COMPARISONS = FOOTER_COMPARISON_SLUGS.map((slug) =>
	COMPARISONS.find((comparison) => comparison.slug === slug)
).filter((comparison): comparison is ComparisonEntry => comparison !== undefined);
